import React from "react";
import { translate } from "react-admin";
// react-admin and ra-ui-materialui each install their own copy of ra-core, so
// the library's built-in buttons and labels can't see the app's translations.
// This gives that second copy the same sl.js texts.
import { TranslationContext } from "ra-ui-materialui/node_modules/ra-core";

const LibraryTranslations = ({ children, locale, translate }) => (
  <TranslationContext.Provider value={{ locale, translate }}>
    {children}
  </TranslationContext.Provider>
);

export default translate(LibraryTranslations);
